import { type StaticImageData } from 'next/image'
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons'
import {
  faBadgePercent,
  faCalendarImage,
  faEarthAmericas,
  faFamily,
  faGem,
  faShip,
  faTreeCity,
  faPerson,
  faUmbrellaBeach,
} from '@fortawesome/pro-light-svg-icons'
import { ugSpaCalendar } from '../CustomIcons/ugSpaCalendar'
import antalya from './images/antalya.webp'
import deutschland from './images/deutschland.webp'
import hurghada from './images/hurghada.webp'
import kos from './images/kos.webp'
import kreta from './images/kreta.webp'
import mallorca from './images/mallorca.webp'
import rhodos from './images/rhodos.webp'
import side from './images/side.webp'
import { type Icon } from './typings'

export function isStaticImageData(icon: Icon): icon is StaticImageData {
  return typeof icon !== 'string' && 'src' in icon
}

export function getSubmenuIcon(name?: string): Icon {
  if (!name) {
    return faAngleDown
  }

  switch (name) {
    case 'faBadgePercent':
      return faBadgePercent
    case 'faUmbrellaBeach':
      return faUmbrellaBeach
    case 'faFamily':
      return faFamily
    case 'faPerson':
      return faPerson
    case 'faCalendarImage':
      return faCalendarImage
    case 'faTreeCity':
      return faTreeCity
    case 'faEarthAmericas':
      return faEarthAmericas
    case 'faShip':
      return faShip
    case 'ugSpaCalendar':
      return ugSpaCalendar
    case 'faGem':
      return faGem
    case 'side':
      return side
    case 'mallorca':
      return mallorca
    case 'hurghada':
      return hurghada
    case 'kreta':
      return kreta
    case 'rhodos':
      return rhodos
    case 'kos':
      return kos
    case 'antalya':
      return antalya
    case 'deutschland':
      return deutschland
    default:
      return faPerson
  }
}

export function isSamePath(currentPathname: string, itemPath: string): boolean {
  if (itemPath.length === 0 || currentPathname === '/') {
    return false
  }

  let itemPathname = itemPath

  try {
    itemPathname = new URL(itemPath).pathname
  } catch (e) {
    // Ignore error, itemPath is not a valid URL
  }

  return itemPathname.startsWith(currentPathname)
}
